import React from 'react';

const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-medal-line',
      title: 'Excellence',
      description:
        'We set the highest standards in everything we do, delivering quality that matches the ambition of our clients',
    },
    {
      icon: 'ri-heart-line',
      title: 'Customer Focus',
      description:
        'Your success is our priority. We listen, adapt, and deliver solutions tailored to your specific needs',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Reliability',
      description:
        'You can count on us to deliver on our promises with consistency, professionalism, and integrity',
    },
    {
      icon: 'ri-lock-line',
      title: 'Security',
      description:
        'We protect your data and confidential information with the highest standards of security and privacy',
    },
    {
      icon: 'ri-scales-line',
      title: 'Ethics',
      description:
        'We operate with transparency, fairness, and respect in all our relationships and business practices',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#0066FF] uppercase text-sm font-semibold tracking-wide mb-4">
            Our Values
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] mb-6">
            What drives us
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Our values guide every decision we make and every relationship we
            build
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-[#F8F9FA] rounded-2xl p-8 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#0066FF] to-[#0052CC] rounded-full mb-6">
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>

              <h3 className="text-xl font-bold text-[#0A1628] mb-3">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
